import React from 'react';
import { useScrollFade } from '../hooks/useScrollFade';
export function DifferenceSection() {
  const {
    ref,
    isVisible
  } = useScrollFade();
  return <section className="py-24 bg-white relative" data-id="element-69">
      {/* Top Divider */}
      <div className="absolute top-0 left-0 right-0 h-px bg-divider w-full max-w-7xl mx-auto" data-id="element-70"></div>

      <div className="container mx-auto px-4 md:px-8 max-w-7xl" data-id="element-71">
        <div ref={ref} className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-72">
          {/* Left: Text Content */}
          <div className={`order-2 lg:order-1 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'}`} data-id="element-73">
            <span className="text-sage font-semibold tracking-[0.2em] uppercase text-xs md:text-sm mb-6 block" data-id="element-74">
              Why This Is Different
            </span>

            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-text-dark leading-tight mb-8" data-id="element-75">
              We don't add anything. We activate everything already inside you.
            </h2>

            <p className="text-text-dark/80 text-base md:text-lg leading-relaxed mb-10" data-id="element-76">
              Radiofrequency energy delivered through ultra-fine needles reaches
              deep into the dermis — the layer where collagen lives. Your skin
              responds the way it was designed to: by healing, rebuilding, and
              tightening. The results aren't from a product. They're from you.
            </p>

            <div className="inline-flex flex-wrap gap-3" data-id="element-77">
              {['Regenerative', 'Collagen-Stimulating', 'No Foreign Substances'].map((badge, i) => <span key={i} className="px-4 py-2 bg-sage/10 text-sage text-sm font-medium rounded-full border border-sage/20" data-id="element-78">
                  {badge}
                </span>)}
            </div>
          </div>

          {/* Right: Image Placeholder */}
          <div className={`order-1 lg:order-2 transition-all duration-1000 delay-300 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`} data-id="element-79">
            <div className="relative aspect-[4/5] w-full overflow-hidden rounded-sm bg-[linear-gradient(45deg,#E8DCC4,#FAF8F5)] shadow-2xl" data-id="element-80">
              {/* Decorative elements for the placeholder to make it feel editorial */}
              <div className="absolute inset-0" data-id="element-81">
                <img src="https://cdn.magicpatterns.com/uploads/pdSvcoVPhv7vu2ky25v7dQ/rf-microneedling.jpg" alt="RF Microneedling treatment" className="w-full h-full object-cover opacity-20" data-id="element-82" />
              </div>
              <div className="absolute bottom-8 left-8 right-8 border-l border-white/40 pl-6" data-id="element-83">
                <p className="font-serif text-text-dark/60 italic text-lg" data-id="element-84">
                  Firm, natural skin.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}